import { createTheme } from '@mui/material/styles';

const themeCustom = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      lgm: 1366,
      xl: 1536,
    },
  },
});
export const XlDown = themeCustom.breakpoints.down('xl');
export const LgMedDown = themeCustom.breakpoints.down('lgm');
export const LgDown = themeCustom.breakpoints.down('lg');
export const MdDown = themeCustom.breakpoints.down('md');
export const SmDown = themeCustom.breakpoints.down('sm');
export const XsDown = themeCustom.breakpoints.down('xs');
